import { render, staticRenderFns } from "./cowDeworming.vue?vue&type=template&id=78fe6560&scoped=true&"
import script from "./cowDeworming.vue?vue&type=script&lang=js&"
export * from "./cowDeworming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fe6560",
  null
  
)

export default component.exports